export default __webpack_public_path__ + "static/media/district-gold.eb2b2a78.svg";